document.addEventListener('click', (event) => {
  const link = event.target.closest('.mobile-nav a');
  if (link) link.closest('.mobile-menu').open = false;
});

document.addEventListener('change', (event) => {
  if (!event.target.matches('.product-form select[name="id"]')) return;

  const form = event.target.closest('.product-form');
  const selectedVariant = event.target.selectedOptions[0];
  const price = form.closest('.product-details').querySelector('.product-detail-price');
  const submit = form.querySelector('.product-submit');
  const available = selectedVariant.dataset.available === 'true';

  price.textContent = selectedVariant.dataset.price;
  submit.disabled = !available;
  submit.textContent = available ? 'Aggiungi al carrello' : 'Esaurito';
});
